import { EntityModel } from '@/interfaces'
import {
  ALL_ACCORDION_BLOCKS_QUERY,
  CREATE_ACCORDION_BLOCK_MUTATION,
  DELETE_ACCORDION_BLOCK_MUTATION,
  FORCE_DELETE_ACCORDION_BLOCK_MUTATION,
  SINGLE_ACCORDION_BLOCK_QUERY,
  UPDATE_ACCORDION_BLOCK_MUTATION,
} from './graphql'
import cmsAccordionBlockItemEntity from '@/entities/cmsAccordionBlockItem/entity'

const cmsAccordionBlockModel: EntityModel = {
  name: 'accordionBlock',
  namePlural: 'accordionBlocks',
  uniqueName: 'cmsAccordionBlock',
  uniqueNamePlural: 'cmsAccordionBlocks',
  path: 'cms/blocks/accordion_block',
  baseUrl: '/cms/blocks/accordion_blocks',
  translationPrefix: 'entities:cmsAccordionBlock.',
  getDisplayName: (values: any) => {
    return 'Accordion Block'
  },
  gql: {
    getAll: ALL_ACCORDION_BLOCKS_QUERY,
    getSingle: SINGLE_ACCORDION_BLOCK_QUERY,
    create: CREATE_ACCORDION_BLOCK_MUTATION,
    update: UPDATE_ACCORDION_BLOCK_MUTATION,
    delete: DELETE_ACCORDION_BLOCK_MUTATION,
    forceDelete: FORCE_DELETE_ACCORDION_BLOCK_MUTATION,
  },
  attributes: {
    items: {
      name: 'items',
      label: 'entities:cmsAccordionBlock.attributes.items.label',
      type: 'entityCollection',
      dataType: '[any]',
      getEntity: () => {
        return cmsAccordionBlockItemEntity
      },
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
  },
}

export default cmsAccordionBlockModel
